import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { DocumentTableRow } from '../../models/documentHub';
import { DeleteDocumentModal } from './DeleteDocumentModal';

export const TableMenu = (props: {
  row: DocumentTableRow;
}): React.ReactElement => {
  const { row } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };
  const handleClose = (event: React.MouseEvent<HTMLLIElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(false);
  };

  const [deleteOpen, setDeleteOpen] = useState(false);
  const handleDelete = (event: React.MouseEvent<HTMLLIElement>) => {
    handleClose(event);
    setDeleteOpen(true);
  };
  return (
    <Box>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertOutlined />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'long-button',
          },
        }}
      >
        <MenuItem
          sx={{ paddingRight: '36px', paddingLeft: '36px' }}
          key={'delete'}
          onClick={handleDelete}
        >
          Delete
        </MenuItem>
      </Menu>
      <DeleteDocumentModal
        setOpen={setDeleteOpen}
        open={deleteOpen}
        row={row}
      />
    </Box>
  );
};
